"use strict";

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = require("~components");

var _arrow = require("~assets/svg/arrow.svg");

var _download = require("~assets/svg/download.svg");

var _mail = require("~assets/svg/mail.svg");

var styles = _interopRequireWildcard(require("./styles.module.scss"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/** ============================================================================
 * Slice
 */


var TextArticle = function TextArticle(_ref) {
  var id = _ref.id,
      className = _ref.className,
      _ref$data = _ref.data,
      backgroundColor = _ref$data.backgroundColor,
      fontColor = _ref$data.fontColor,
      heading = _ref$data.heading,
      headingStyle = _ref$data.headingStyle,
      subheading = _ref$data.subheading,
      status = _ref$data.status,
      padded = _ref$data.padded,
      dockedTop = _ref$data.dockedTop,
      flattenTop = _ref$data.flattenTop,
      dockedBottom = _ref$data.dockedBottom,
      flattenBottom = _ref$data.flattenBottom,
      buttonIcon = _ref$data.buttonIcon,
      buttonType = _ref$data.buttonType,
      buttonAlignment = _ref$data.buttonAlignment,
      button = _ref$data.button,
      _rawBody = _ref$data._rawBody; // ---------------------------------------------------------------------------
  // variables

  var buttonIconJSX = null;
  var buttonJSX = null; // ---------------------------------------------------------------------------
  // render

  switch (buttonIcon === null || buttonIcon === void 0 ? void 0 : buttonIcon.toLowerCase()) {
    case "arrow":
      buttonIconJSX = /*#__PURE__*/_react.default.createElement(_arrow.ReactComponent, {
        className: styles.arrowIcon,
        fill: "white"
      });
      break;

    case "download":
      buttonIconJSX = /*#__PURE__*/_react.default.createElement(_download.ReactComponent, {
        fill: "white",
        className: styles.downloadIcon
      });
      break;

    case "mail":
      buttonIconJSX = /*#__PURE__*/_react.default.createElement(_mail.ReactComponent, {
        className: styles.mailIcon,
        fill: "white"
      });
      break;

    case "none":
    default:
      break;
  }

  if ((button === null || button === void 0 ? void 0 : button.text) !== "" && button !== null && button !== void 0 && button.url) {
    switch (buttonType === null || buttonType === void 0 ? void 0 : buttonType.toLowerCase()) {
      case "bordered":
        buttonJSX = /*#__PURE__*/_react.default.createElement(_components.Button, {
          color: "white",
          to: button.url,
          transparent: true
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "button-text"
        }, button.text), buttonIconJSX);
        break;

      case "inline":
      default:
        buttonJSX = /*#__PURE__*/_react.default.createElement(_components.Link, {
          to: button.url
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "button-text"
        }, button.text), buttonIconJSX);
        break;
    }
  }

  return /*#__PURE__*/_react.default.createElement("section", {
    sliceid: id,
    className: [className, styles.container, dockedTop ? styles.dockedTop : "", flattenTop ? styles.flattenTop : "", dockedBottom ? styles.dockedBottom : "", flattenBottom ? styles.flattenBottom : "", padded ? styles.padded : ""].join(" "),
    style: {
      background: (backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.hex) || "transparent",
      color: (fontColor === null || fontColor === void 0 ? void 0 : fontColor.hex) || "white"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.grid
  }, /*#__PURE__*/_react.default.createElement("header", {
    className: styles.header
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "".concat(styles.headerHeading, " ").concat((headingStyle === null || headingStyle === void 0 ? void 0 : headingStyle.style) || "b1")
  }, heading), subheading && /*#__PURE__*/_react.default.createElement("h3", {
    className: "b1"
  }, subheading), status && /*#__PURE__*/_react.default.createElement("h3", {
    className: "".concat(styles.headerStatus, " b2")
  }, status)), /*#__PURE__*/_react.default.createElement("div", {
    className: [styles.content, buttonAlignment === "Right" ? styles.contentFlex : ""].join(" ")
  }, _rawBody && /*#__PURE__*/_react.default.createElement("div", {
    className: [styles.rawBody]
  }, /*#__PURE__*/_react.default.createElement(_components.PortableText, {
    blocks: _rawBody
  })), buttonJSX && /*#__PURE__*/_react.default.createElement("div", {
    className: [styles.buttonContainer, buttonAlignment === "Right" ? styles.buttonContainerRightAligned : ""].join(" ")
  }, buttonJSX))));
};

var _default = TextArticle;
exports.default = _default;